<div class="export-box">
  <button mat-flat-button (click)="onPdfExport()">
    <mat-icon svgIcon="pdf"></mat-icon>
    <p>.PDF</p>
  </button>
  <button mat-flat-button (click)="onExcelExport()">
    <mat-icon svgIcon="excel"></mat-icon>
    <p>.XLSX</p>
  </button>
</div>
